import { strapi } from '@strapi/client';
import { API_URL, NEXT_PUBLIC_API_TOKEN } from '../configs/commons';

const client = strapi({
    baseURL: `${API_URL}/api`,
    auth: NEXT_PUBLIC_API_TOKEN
});

export default client;